import React, { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { CheckCircleIcon, InformationCircleIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

const iconMap = {
  success: <CheckCircleIcon className="ms-2 h-6 w-6 text-green-400" />,
  danger: <XCircleIcon className="ms-2 h-6 w-6 text-red-400" />,
  info: <InformationCircleIcon className="ms-2 h-6 w-6 text-blue-400" />,
};

export const Toast = ({ title, description, type = "info", show, setShow }) => {
  return (
    <div className="pointer-events-none fixed inset-0 flex items-end px-4 py-5 sm:items-start sm:p-6">
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        <Transition
          show={show}
          as={Fragment}
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterTo="translate-y-0 opacity-100 sm:translate-x-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-md bg-white shadow-md ring-1 ring-black/5">
            <div className="py-4">
              <div className="flex items-start">
                <div className="shrink-0">{iconMap[type]}</div>
                <div className="ml-3 w-0 flex-1 pt-0.5">
                  {title && <p className="font-semibold text-gray-800 ">{title}</p>}
                  {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}
                </div>
                <div className="ml-4 flex shrink-0">
                  <XMarkIcon data-testid="icon-close" className="mr-4 h-4 w-4 cursor-pointer" onClick={() => setShow(false)} />
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
};
